/* ----------------------------------------
   DIRECT CHECKOUT A/B TEST (Shoplift)
   Default (A): product CTAs keep their current behavior
   Variant B:   product CTAs go straight to checkout

   Loaded on every page (layout/theme.liquid); runs only on the
   test product pages listed in urls below.

----------------------------------------- */
(() => {
  'use strict';

  // Test product pages
  const urls = [
    '/products/the-audien-atom-x-otc-hearing-aid',
    '/products/audien-atom-air-otc-hearing-aids',
    '/products/atom-pro-2',
    '/products/audien-atom-one-hearing-aid',
    '/products/audien-ion-pro-otc-hearing-aids',
    '/products/ion-iq',
    '/products/ion-air',
  ];

  const path = window.location.pathname.replace(/\/+$/, '');

  if (!urls.includes(path)) return;

  // Shoplift hypothesis ID for variant B (direct checkout)
  const VARIANT_B_ID = '01a1a0a9-bc36-7cf7-ac86-b4876cb0e3d8';
  const CLASS_B = 'wlsn-direct-checkout-ab-b';

  const CTA_SCOPE = [
    'wollson-shop',      // wollson-shop section
    'wlsn-sticky-cta',   // wollson-shop sticky CTA
  ].join(',');
  const CART_PERMALINK_RE = /\/cart\/\d+:\d+/;

  const WAIT_TIMEOUT_MS = 5000;
  const WAIT_STEP_MS = 50;

  let isVariantB = false;

  const waitForShoplift = () =>
    new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        const api = window.shoplift;
        if (api && typeof api.isHypothesisActive === 'function') return resolve(api);
        if (Date.now() - start >= WAIT_TIMEOUT_MS) return resolve(null);
        setTimeout(check, WAIT_STEP_MS);
      };
      check();
    });

  const triggerTestOnLanding = async () => {
    const api = await waitForShoplift();
    if (!api) return false;
    return Boolean(await api.isHypothesisActive(VARIANT_B_ID));
  };

  // Variant B only: add data-direct-checkout to the clicked CTA button
  const onCtaClick = (e) => {
    if (!isVariantB) return;

    const anchor = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!anchor) return;
    if (!anchor.closest(CTA_SCOPE)) return;
    if (!CART_PERMALINK_RE.test(anchor.getAttribute('href') || '')) return;

    anchor.setAttribute('data-direct-checkout', 'true');
  };

  window.addEventListener('click', onCtaClick, { capture: true });

  triggerTestOnLanding()
    .then((isB) => {
      isVariantB = isB;
      document.documentElement.classList.toggle(CLASS_B, isB);
    })
    .catch(() => {
      isVariantB = false;
    });
})();
